module.exports = __webpack_public_path__ + "static/img/gg.98f67a6f.svg";